
import "@/styles/about-us.scss";
import { Slider } from "apower-ui";
import { isMobile } from "@/utils/is";
import { Carousel, CarouselItem } from "apower-ui";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            
const components = [Slider, Carousel, CarouselItem];

components.forEach((component) => {
  Vue.component(component.name, component);
});

new Vue({
  components: {
    // PicwishDemo,
  },
  data() {
    return {
      isMobile: isMobile,
      tabIndex: 1,
      tabColor: 1,
    };
  },
  mounted() {
    document.addEventListener("scroll", this.pageScroll);
  },

  created() {
    this.pageScroll();
  },
  methods: {
    pageScroll: function () {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 100) {
        document.getElementById("ap-header").classList.remove("nofixed");
      } else {
        document.getElementById("ap-header").classList.add("nofixed");
      }
    },
  },
}).$mount("#app");

          })
        